import {
  Chip as ChipCore,
  TextField as TextFieldCore,
} from '@material-ui/core';
import { Autocomplete as AutocompleteCore } from '@material-ui/lab';
import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

type ChipProps = {
  isInvalid: boolean;
};

export const Container = lib.styled.div`
    padding: 5px;
    border-radius: 7px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;

    .MuiChip-avatar {
        svg {
            width: 18px;
            height: 18px;

            path {
                fill: rgb(68, 80, 88, 1);
                fill-opacity: 1;
            } 
        }
    }

    .MuiPaper-elevation1 {
        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    }

    .MuiInput-underline:after {
        display: none;
    }

    .MuiInput-underline:before {
        display: none;
    }
    .MuiFormControl-root {
        margin-bottom: 0px;
    }

    .MuiChip-root {
        height: 30px;
        border-radius: 7px;
        padding-left: 5px;
        padding-right: 5px;
    }
    
    .MuiChip-label {
        padding-top: 2px;
        cursor: pointer;
    }

    .icon-chip {
        margin-top: 6px;
    }

    .icon-close {
        color: ${colors.black};
        width: 15px;
        height: 15px
    }
`;

export const Autocomplete = lib.styled(AutocompleteCore)`
    padding-right: 5px !important;
    padding-left: 5px !important;
    overflow-y: hidden;
    max-height: 40px; 
    transition: max-height 0.5s ease;

    &.Mui-focused {
        max-height: 400px;
        overflow-y: visible;
    }

    ${({ isInvalid }: ChipProps) =>
      isInvalid &&
      `
        max-height: 400px !important;
        overflow-y: visible !important;
    `}

    &:hover {
        max-height: 400px;
        overflow-y: visible;
    }
    
    /* 🔒 Keep endAdornment fixed */
    .MuiAutocomplete-endAdornment {
        top: 0;
        bottom: auto;
        transform: none;
        align-items: flex-start;
        padding-top: 4px;
    }
`;

export const TextField = lib.styled(TextFieldCore)`
    input::placeholder {
        font-size: ${fonts.placeholder}px;
        font-style: italic;
    }
`;

export const Chip = lib.styled(ChipCore)`
    ${({ isInvalid }: ChipProps) =>
      isInvalid &&
      `
        border: 1px solid ${colors.red} !important;
        background-color: ${colors.red08} !important;
        color: ${colors.red} !important;
    `}
`;

export const GroupHeader = lib.styled.div`
    position: sticky;
    top: -8px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 10px 10px 15px;
    font-weight: 700;
    background-color: ${colors.white};
    color: ${colors.darkGray11};

    .icon-groups {
        div {
            display: flex;
            justify-content: center;
            align-items: center;    
        }
    }

    svg {
        width: 20px;
        height: 20px;
        
        path {
            fill: ${colors.lightBlue16} !important;
            fill-opacity: 0.7 !important;
        }
    }
`;

export const GroupItems = lib.styled.ul``;
